<template>
    <rkm-data-table
        :fields="fields.datatables.tabelaCid"
        :repository="repositories.tabelaCid"
        ref="DataTable"
        sort-by="nome"
        search-by="codigo"
    >
        <template v-slot:cell(nome)="{ value }">
            {{ value }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="item.isAtivo"
                @click.stop="handleDeactivate(item)"
                color="warning"
                authorize="update-parametrizacao-tabela-cid"
                title="Desativar"
                small
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                v-else
                @click.stop="handleActivate(item)"
                color="success"
                authorize="update-parametrizacao-tabela-cid"
                title="Ativar"
                small
            >
                <rkm-icon icon="ban" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error, stringCase } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                datatables: {
                    tabelaCid: [
                        {
                            key: 'codigo',
                            name: 'codigo',
                            label: 'Código',
                            searchable: true,
                            sortable: true
                        },
                        {
                            key: 'nome',
                            name: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true
                        },
                        {
                            key: 'status',
                            name: 'isAtivo',
                            label: 'Status',
                            searchable: false,
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: 'Ações'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            tabelaCid: this.getConectaSusRepository('parametrizacao.tabelaCid')
        }
    },
    methods: {
        handleDeactivate(item) {

            this.repositories.tabelaCid.update(item.id, this.prepareData(item))
                .then(() => this.$refs.DataTable.refresh())
        },
        handleActivate(item) {

            this.repositories.tabelaCid.update(item.id, this.prepareData(item))
                .then(() => this.$refs.DataTable.refresh())
        },
        prepareData(item) {

            if (item.isAtivo === 1) {
                
                item.isAtivo = false
            }

            if (item.isAtivo === 0) {
                
                item.isAtivo = true
            }

            return this.camelObjectKeysToSnakeRecursive(item)
        }
    },
    mixins: [repository, error, stringCase]
}
</script>